import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import BrandTagRequestListContainer from '../../containers/brand/BrandTagRequestListContainer';
import { BRAND_PAGE_NAME } from '../../constants/service/app/brandConstants';

const BrandTagRequestList = () => {
  return (
    <PageTemplate pageName={BRAND_PAGE_NAME.BRAND_TAG_REQUEST_LIST}>
      <BrandTagRequestListContainer pageName={BRAND_PAGE_NAME.BRAND_TAG_REQUEST_LIST} />
    </PageTemplate>
  );
};

export default BrandTagRequestList;
